<div
  class="modal-overlay"
  [class.android-platform]="isAndroid"
  *ngIf="isOpen"
  (click)="dismiss()"
>
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Mobile Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        {{ translations.broadcastTranslation || "Broadcast Translation" }}
      </h2>
      <button
        (click)="dismiss()"
        class="close-button"
        type="button"
        aria-label="Close"
      >
        <ion-icon name="close"></ion-icon>
        <span class="close-text">X</span>
      </button>
    </div>

    <ion-content>
      <div class="container">
        <!-- Mode Selection -->
        <ion-card class="mode-card">
          <ion-card-content>
            <div class="mode-buttons">
              <ion-button
                [fill]="mode === 'speaker' ? 'solid' : 'outline'"
                [color]="mode === 'speaker' ? 'primary' : 'medium'"
                (click)="setMode('speaker')"
                [disabled]="isBroadcasting || isJoined"
              >
                <ion-icon slot="start" name="mic"></ion-icon>
                {{ translations.speaker || "Speaker" }}
              </ion-button>
              <ion-button
                [fill]="mode === 'listener' ? 'solid' : 'outline'"
                [color]="mode === 'listener' ? 'primary' : 'medium'"
                (click)="setMode('listener')"
                [disabled]="isBroadcasting || isJoined"
              >
                <ion-icon slot="start" name="headset"></ion-icon>
                {{ translations.listener || "Listener" }}
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>

        <!-- SPEAKER MODE -->
        <div *ngIf="mode === 'speaker'">
          <!-- Language Selection -->
          <ion-card class="control-card">
            <ion-card-content>
              <div class="language-selection">
                <div class="language-group">
                  <div class="flex items-center gap-2">
                    <label>{{
                      translations.sourceLanguage || "Source Language"
                    }}</label>
                    <button
                      type="button"
                      class="info-icon"
                      (click)="showSourceLanguageInfo($event)"
                      [attr.aria-label]="translations.sourceLanguageSet || 'Source language information'"
                    >
                      !
                    </button>
                  </div>
                  <ion-select
                    [(ngModel)]="selectedSourceLanguage"
                    [disabled]="true"
                  >
                    <ion-select-option
                      *ngFor="let lang of availableLanguages"
                      [value]="lang.code"
                      [disabled]="
                        isLiveTranslationEnabled() &&
                        !isLiveSourceSupported(lang.code)
                      "
                    >
                      {{ getLanguageName(lang.code) }}
                      <ng-container
                        *ngIf="
                          isLiveTranslationEnabled() &&
                          !isLiveSourceSupported(lang.code)
                        "
                        >({{
                          translations.liveTranslationNotSupported ||
                            "not available in live translation"
                        }})</ng-container
                      >
                    </ion-select-option>
                  </ion-select>
                  <p
                    *ngIf="isLiveTranslationEnabled() && usesLiveTranslation()"
                    class="live-badge"
                  >
                    {{ translations.liveTranslation || "Live translation" }}
                  </p>
                  <p
                    *ngIf="isLiveTranslationEnabled() && !usesLiveTranslation()"
                    class="live-notice"
                  >
                    {{ getLiveFallbackNotice() }}
                  </p>
                </div>

                <div class="language-group">
                  <label
                    >{{
                      translations.targetLanguage || "Target Language"
                    }}
                    (Default)</label
                  >
                  <ion-select
                    [(ngModel)]="selectedTargetLanguage"
                    [disabled]="isBroadcasting"
                  >
                    <ion-select-option
                      *ngFor="let lang of getAvailableLanguagesForTarget()"
                      [value]="lang.code"
                    >
                      {{ getLanguageName(lang.code) }}
                    </ion-select-option>
                  </ion-select>
                </div>

                <!-- Extra Languages List (appears below target language) -->
                <div
                  class="extra-languages-list"
                  *ngIf="extraLanguages.length > 0"
                >
                  <div
                    *ngFor="let langCode of extraLanguages; let i = index"
                    class="extra-language-item"
                  >
                    <ion-select
                      [(ngModel)]="extraLanguages[i]"
                      [disabled]="isBroadcasting"
                    >
                      <ion-select-option
                        *ngFor="
                          let availableLang of getAvailableLanguagesForExtra(i)
                        "
                        [value]="availableLang.code"
                      >
                        {{ getLanguageName(availableLang.code) }}
                      </ion-select-option>
                    </ion-select>
                    <ion-button
                      fill="clear"
                      size="small"
                      (click)="removeExtraLanguage(i)"
                      [disabled]="isBroadcasting"
                      type="button"
                      class="remove-language-button"
                      color="danger"
                    >
                      <ion-icon name="close" slot="start"></ion-icon>
                      <span>{{ translations.removeLanguage || "Remove" }}</span>
                    </ion-button>
                  </div>
                </div>

                <!-- Extra Languages (up to 3) -->
                <div class="extra-languages" *ngIf="extraLanguages.length < 3">
                  <div class="add-language-wrapper">
                    <ion-button
                      fill="outline"
                      size="small"
                      (click)="addExtraLanguage()"
                      [disabled]="isBroadcasting"
                    >
                      <ion-icon slot="start" name="add"></ion-icon>
                      {{ translations.addLanguage || "Add Language" }}
                    </ion-button>
                    <button
                      type="button"
                      class="info-icon"
                      (click)="showWordCountInfo($event)"
                    >
                      !
                    </button>
                  </div>
                </div>
              </div>

              <!-- Broadcast Code Display -->
              <div *ngIf="broadcastCode" class="broadcast-code">
                <p class="code-label">
                  {{ translations.broadcastCode || "Broadcast Code" }}
                </p>
                <div class="code-display">
                  <span class="code-value">{{ broadcastCode }}</span>
                  <ion-button fill="clear" size="small" (click)="copyCode()">
                    <ion-icon name="copy"></ion-icon>
                  </ion-button>
                </div>
                <p class="code-hint">
                  {{
                    translations.shareCode || "Share this code with listeners"
                  }}
                </p>
              </div>

              <!-- Speaking Indicator -->
              <div
                *ngIf="isBroadcasting && recording"
                class="speaking-indicator"
              >
                <ion-icon name="mic" class="pulsing-mic"></ion-icon>
                <span>{{ translations.speaking || "Speaking..." }}</span>
              </div>
              <p *ngIf="isBroadcasting && liveCaption" class="live-caption">
                {{ liveCaption }}
              </p>

              <!-- Broadcast Controls -->
              <div class="button-group">
                <ion-button
                  expand="block"
                  color="success"
                  size="large"
                  type="button"
                  (click)="startBroadcasting()"
                  [disabled]="isBroadcasting"
                >
                  <ion-icon slot="start" name="radio"></ion-icon>
                  <span>{{
                    translations.startBroadcast || "Start Broadcast"
                  }}</span>
                </ion-button>
                <ion-button
                  expand="block"
                  color="danger"
                  size="large"
                  type="button"
                  (click)="stopBroadcasting()"
                  [disabled]="!isBroadcasting"
                >
                  <ion-icon slot="start" name="stop"></ion-icon>
                  <span>{{
                    translations.stopBroadcast || "Stop Broadcast"
                  }}</span>
                </ion-button>
                <!-- Audio Toggle Button -->
                <ion-button
                  expand="block"
                  [fill]="audioEnabled() ? 'solid' : 'outline'"
                  [color]="audioEnabled() ? 'primary' : 'medium'"
                  size="large"
                  (click)="toggleAudio()"
                  [disabled]="!isBroadcasting"
                  class="action-button audio-button"
                >
                  <ion-icon
                    slot="start"
                    name="volume-high"
                    aria-hidden="true"
                  ></ion-icon>
                  <span>{{
                    audioEnabled()
                      ? translations.audioOn || "Audio: ON"
                      : translations.audioOff || "Audio: OFF"
                  }}</span>
                  <ion-icon
                    *ngIf="!audioEnabled()"
                    slot="end"
                    name="close-circle"
                    style="font-size: 1.2em; margin-left: 8px"
                    aria-hidden="true"
                  ></ion-icon>
                </ion-button>
              </div>

              <!-- Lecture Mode Checkbox -->
              <div
                class="lecture-mode-section mt-3"
                *ngIf="!isLiveTranslationEnabled()"
              >
                <ion-item lines="none" class="lecture-mode-item">
                  <ion-checkbox
                    [(ngModel)]="lectureMode"
                    [disabled]="isBroadcasting"
                    slot="start"
                  ></ion-checkbox>
                  <ion-label class="lecture-mode-label">
                    <div class="lecture-mode-header">
                      <h3>{{ translations.lectureMode || "Lecture Mode" }}</h3>
                      <button
                        type="button"
                        class="info-icon"
                        (click)="showLectureModeInfo($event)"
                        (touchstart)="showLectureModeInfo($event)"
                        [disabled]="isBroadcasting"
                        [attr.aria-label]="translations.lectureModeDescription || 'Lecture mode information'"
                      >
                        !
                      </button>
                    </div>
                  </ion-label>
                </ion-item>
              </div>

              <!-- Advanced Model Checkbox -->
              <div
                class="lecture-mode-section mt-2"
                *ngIf="!isLiveTranslationEnabled()"
              >
                <ion-item lines="none" class="lecture-mode-item">
                  <ion-checkbox
                    [ngModel]="isAdvancedModelEnabled()"
                    (ngModelChange)="onAdvancedModelChange($event)"
                    [disabled]="isBroadcasting || isGlobalAdvancedModelEnabled()"
                    slot="start"
                  ></ion-checkbox>
                  <ion-label class="lecture-mode-label">
                    <div class="lecture-mode-header">
                      <h3>
                        {{
                          translations.advancedModel ||
                            "Advanced translation model"
                        }}
                      </h3>
                      <button
                        type="button"
                        class="info-icon"
                        (click)="showAdvancedModelInfo($event)"
                        (touchstart)="showAdvancedModelInfo($event)"
                        [attr.aria-label]="translations.advancedModelDescription || 'Advanced translation model information'"
                      >
                        !
                      </button>
                    </div>
                  </ion-label>
                </ion-item>
              </div>
            </ion-card-content>
          </ion-card>

          <!-- Speaker Source Language Transcripts (for verification) -->
          <ion-card
            *ngIf="
              mode === 'speaker' &&
              isBroadcasting &&
              speakerSourceTexts.length > 0
            "
            class="transcripts-card"
          >
            <ion-card-header>
              <ion-card-title>
                <ion-icon name="document-text" class="card-icon"></ion-icon>
                <span
                  >{{ translations.yourSpeech || "Your Speech" }} ({{
                    speakerSourceTexts.length
                  }})</span
                >
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="transcript-list">
                <div
                  *ngFor="
                    let item of getReversedSourceTexts();
                    trackBy: trackSpeakerSourceText;
                    let i = index
                  "
                  class="transcript-item"
                >
                  <div class="transcript-header">
                    <div class="transcript-header-left">
                      <ion-badge color="primary">{{
                        getLanguageName(selectedSourceLanguage)
                      }}</ion-badge>
                      <span class="timestamp">{{
                        formatTime(item.timestamp)
                      }}</span>
                    </div>
                  </div>
                  <p class="transcript-text">{{ item.text }}</p>
                </div>
              </div>
            </ion-card-content>
          </ion-card>

          <!-- Empty State for Speaker Transcripts -->
          <ion-card
            *ngIf="
              mode === 'speaker' &&
              isBroadcasting &&
              speakerSourceTexts.length === 0
            "
            class="empty-card"
          >
            <ion-card-content>
              <div class="empty-state">
                <ion-icon name="mic-outline" class="empty-icon"></ion-icon>
                <p>
                  {{
                    translations.speakToSeeTranscripts ||
                      "Start speaking to see your transcriptions here"
                  }}
                </p>
              </div>
            </ion-card-content>
          </ion-card>
        </div>

        <!-- LISTENER MODE -->
        <div *ngIf="mode === 'listener'">
          <ion-card class="control-card">
            <ion-card-content>
              <!-- Join Session -->
              <div *ngIf="!isJoined" class="join-section">
                <div class="language-group">
                  <label>{{
                    translations.enterCode || "Enter Broadcast Code"
                  }}</label>
                  <ion-input
                    [(ngModel)]="enteredCode"
                    type="text"
                    placeholder="000000"
                    maxlength="6"
                    [disabled]="isJoined"
                  ></ion-input>
                </div>

                <div class="language-group">
                  <label>{{
                    translations.selectLanguage || "Select Language"
                  }}</label>
                  <ion-select
                    [(ngModel)]="selectedListenerLanguage"
                    [disabled]="isJoined"
                  >
                    <ion-select-option
                      *ngFor="let lang of getAvailableLanguagesForListener()"
                      [value]="lang.code"
                    >
                      {{ getLanguageName(lang.code) }}
                    </ion-select-option>
                  </ion-select>
                  <p
                    class="language-hint"
                    *ngIf="isJoined && availableListenerLanguages.length > 0"
                  >
                    {{
                      translations.availableLanguages || "Available languages"
                    }}: {{ getAvailableLanguagesDisplay() }}
                  </p>
                </div>

                <ion-button
                  expand="block"
                  color="primary"
                  size="large"
                  (click)="joinSession()"
                  [disabled]="isJoined || !enteredCode"
                >
                  <ion-icon slot="start" name="enter"></ion-icon>
                  <span>{{
                    translations.joinBroadcast || "Join Broadcast"
                  }}</span>
                </ion-button>
              </div>

              <!-- Joined Session -->
              <div *ngIf="isJoined" class="joined-section">
                <div class="session-info">
                  <p class="session-code">
                    {{ translations.listeningTo || "Listening to" }}:
                    {{ enteredCode }}
                  </p>
                  <p class="session-language">
                    {{ getLanguageName(selectedListenerLanguage) }}
                  </p>
                </div>

                <div class="language-group">
                  <label>{{
                    translations.selectLanguage || "Select Language"
                  }}</label>
                  <ion-select
                    [(ngModel)]="selectedListenerLanguage"
                    [disabled]="!isJoined"
                    (ionChange)="onListenerLanguageChange()"
                  >
                    <ion-select-option
                      *ngFor="let lang of availableListenerLanguages"
                      [value]="lang"
                    >
                      {{ getLanguageName(lang) }}
                    </ion-select-option>
                  </ion-select>
                  <p
                    class="language-hint"
                    *ngIf="isJoined && availableListenerLanguages.length > 0"
                  >
                    {{
                      translations.availableLanguages || "Available languages"
                    }}: {{ getAvailableLanguagesDisplay() }}
                  </p>
                </div>

                <ion-button
                  expand="block"
                  color="danger"
                  size="large"
                  (click)="leaveSession()"
                >
                  <ion-icon slot="start" name="exit"></ion-icon>
                  <span>{{
                    translations.leaveBroadcast || "Leave Broadcast"
                  }}</span>
                </ion-button>
              </div>
            </ion-card-content>
          </ion-card>
        </div>

        <!-- Audio Toggle (for listeners) -->
        <ion-card *ngIf="mode === 'listener' && isJoined" class="control-card">
          <ion-card-content>
            <ion-button
              expand="block"
              [fill]="audioEnabled() ? 'solid' : 'outline'"
              [color]="audioEnabled() ? 'primary' : 'medium'"
              size="large"
              (click)="toggleAudio()"
            >
              <ion-icon slot="start" name="volume-high"></ion-icon>
              <span>{{
                audioEnabled()
                  ? translations.audioOn || "Audio: ON"
                  : translations.audioOff || "Audio: OFF"
              }}</span>
            </ion-button>
          </ion-card-content>
        </ion-card>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="error-message">
          <p>{{ errorMessage }}</p>
        </div>

        <!-- Messages (for listeners) -->
        <ion-card
          *ngIf="
            mode === 'listener' && isJoined && getFilteredMessages().length > 0
          "
          class="messages-card"
        >
          <ion-card-header>
            <ion-card-title>
              <ion-icon name="chatbubbles" class="card-icon"></ion-icon>
              <span
                >{{ translations.messages || "Messages" }} ({{
                  getFilteredMessages().length
                }})</span
              >
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <div class="message-list">
              <div
                *ngFor="let message of getFilteredMessages()"
                class="message-item"
              >
                <div class="message-header">
                  <ion-badge color="primary">{{
                    formatTime(message.timestamp)
                  }}</ion-badge>
                </div>
                <p class="message-text">{{ message.translatedText }}</p>
                <p
                  class="message-original"
                  *ngIf="message.sourceText !== message.translatedText"
                >
                  <small>{{ message.sourceText }}</small>
                </p>
              </div>
            </div>
          </ion-card-content>
        </ion-card>

        <!-- Empty State (for listeners) -->
        <ion-card
          *ngIf="
            mode === 'listener' &&
            isJoined &&
            getFilteredMessages().length === 0
          "
          class="empty-card"
        >
          <ion-card-content>
            <div class="empty-state">
              <ion-icon name="headset-outline" class="empty-icon"></ion-icon>
              <p>
                {{
                  translations.waitingForMessages || "Waiting for messages..."
                }}
              </p>
            </div>
          </ion-card-content>
        </ion-card>
      </div>
    </ion-content>
  </div>
</div>
